const HeartAni = (props) => {

    return (
        <div id={props.id}>
            <div className={props.id === "heart-ani-2" ? "heart-2" : "heart"}>
                <i className="fa-solid fa-heart" id={props.id === "heart-ani-2" ? "i-2" : "i-1"}></i>
            </div>
        </div>
    )
};

export default HeartAni;
